import { useTranslation } from 'react-i18next';
import { isMaskedChange, type AuditChanges as AuditChangesMap } from 'api/adminAuditApi';
import ChangeRow from './ChangeRow';

interface AuditChangesProps {
  changes: AuditChangesMap;
}

/**
 * Before → After for one event (J3, CA6, CA25/CA26 via the shared label helpers). Reusable as-is
 * for the expanded row of the global view (PR9) — no fetching, props only.
 */
const AuditChanges = ({ changes }: AuditChangesProps) => {
  const { t } = useTranslation();
  const fields = Object.entries(changes);
  const isCreation = fields.every(([, change]) => !isMaskedChange(change) && !('from' in change));
  const headerClass = 'text-[11px] font-semibold uppercase tracking-[.05em] text-muted-foreground/70';

  return (
    <div className="grid grid-cols-[minmax(96px,150px)_1fr_14px_1fr] items-start gap-x-3 gap-y-3 rounded-[10px] border bg-muted/30 p-3 text-[13px]">
      <span className={headerClass}>{t('Field')}</span>
      <span className={headerClass}>{isCreation ? t('Before (none)') : t('Before')}</span>
      <span aria-hidden="true" />
      <span className={headerClass}>{t('After')}</span>
      {fields.map(([field, change]) => (
        <ChangeRow key={field} field={field} change={change} />
      ))}
    </div>
  );
};

export default AuditChanges;
